import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormArray } from '@angular/forms';
import { ColumnModel, IValueChanged, ODataModel, TableModel } from '@evorait/pace-core';
import { faChevronDown, faChevronUp } from '@fortawesome/free-solid-svg-icons';
import * as _ from 'lodash';

@Component({
    selector: 'pace-data-maintenance-sysconfig-expandable',
    templateUrl: './data-maintenance-sysconfig-expandable.component.html',
    styleUrls: ['./data-maintenance-sysconfig-expandable.component.scss'],
})
export class DataMaintenanceSysconfigExpandableComponent {
    @Input() public model: TableModel<ODataModel>;
    @Input() public technicalIdOrFunctionalLocationLabel: string;
    @Input() public formChildren: FormArray;
    @Input() public displayReasonText: boolean;
    @Input() public row: ODataModel;
    @Input() public columns: ColumnModel[];
    public faChevronDown = faChevronDown;
    public faChevronUp = faChevronUp;
    public isCollapsed = true;
    @Output()
    public modelValueChangedEvent = new EventEmitter<IValueChanged>();

    public rowClick(): void {
        this.model.selectedRow = this.row;
        this.isCollapsed = !this.isCollapsed;
    }

    public modelValueChanged(event: IValueChanged): void {
        this.modelValueChangedEvent.emit(event);
    }

    public get<T>(field: string): T {
        return _.get(this.row, field);
    }
}
